import Logger from "./logger";

const NAME = "ChatBot";

export default function ChatBot() {
	Logger.info(`${NAME} > init`);
	const date = new Date(
		new Date().toLocaleString("en-US", { timeZone: "America/Toronto" })
	); // timezone ex: Asia/Jerusalem
	const day = date.getDay();
	const hour = date.getHours();
	const minutes = date.getMinutes();

	function insertAda() {
		Logger.info(`${NAME} > init > insertADA`);
		const s = document.createElement("script");
		s.setAttribute("id", "__ada");
		s.setAttribute("data-handle", "muse");
		s.setAttribute("src", "https://static.ada.support/embed2.js");
		document.body.appendChild(s);
	}

	function insertSalesforce() {
		Logger.info(`${NAME} > init > insertSalesforce`);

		var initESW = function (gslbBaseURL) {
			Logger.info(`${NAME} > init > insertSalesforce > intESW`);
			embedded_svc.settings.storageDomain = "choosemuse.com";
			embedded_svc.settings.displayHelpButton = true; //Or false
			embedded_svc.settings.language = ""; //For example, enter 'en' or 'en-US'

			embedded_svc.settings.defaultMinimizedText = "Chat With Us!";
			//(Defaults to Chat with an Expert)
			embedded_svc.settings.disabledMinimizedText = "Offline"; //(Defaults to Agent Offline)

			//embedded_svc.settings.loadingText = ''; //(Defaults to Loading)
			//embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)

			// Settings for Chat
			//embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
			// Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
			// Returns a valid button ID.
			//};
			//embedded_svc.settings.prepopulatedPrechatFields = {}; //Sets the auto-population of pre-chat form fields
			//embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
			//embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)

			embedded_svc.settings.enabledFeatures = ["LiveAgent"];
			embedded_svc.settings.entryFeature = "LiveAgent";

			embedded_svc.init(
				"https://choosemuse.my.salesforce.com",
				"https://choosemuse.my.site.com/",
				gslbBaseURL,
				"00D41000000g4dE",
				"Chat_TEST",
				{
					baseLiveAgentContentURL:
						"https://c.la2-c2-ia2.salesforceliveagent.com/content",
					deploymentId: "57241000000XZBU",
					buttonId: "5732M000000DB5u",
					baseLiveAgentURL: "https://d.la2-c2-ia2.salesforceliveagent.com/chat",
					eswLiveAgentDevName: "Chat_TEST",
					isOfflineSupportEnabled: false,
				}
			);
		};

		if (!window.embedded_svc) {
			var s = document.createElement("script");
			s.setAttribute(
				"src",
				"https://choosemuse.my.salesforce.com/embeddedservice/5.0/esw.min.js"
			);
			s.onload = function () {
				initESW(null);
			};
			document.body.appendChild(s);
		} else {
			initESW("https://service.force.com");
		}
	}

	// If mon thru fri (9-5pm ET)
	if (day <= 5 && hour >= 9 && hour < 17) {
		Logger.info(
			`${NAME} > init > Within business hours: ${day} ${hour} ${minutes}`
		);
		insertSalesforce();
	}
	// outside business hours
	else {
		Logger.info(
			`${NAME} > init > Outside of business hours: ${day} ${hour} ${minutes}`
		);
		insertAda();
	}
}
